module.exports = __webpack_public_path__ + "static/media/599.767 (4).52278c43.pdf";